import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec1de806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column justify-content-center p-1 gap-5 container" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_6 = { class: "lista_atendimentos card p-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "header_list d-flex col-12 p-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-5 d-flex justify-content-start subtitulo" }, "NOME"),
  /*#__PURE__*/_createElementVNode("span", { class: "col-5 d-flex justify-content-start subtitulo" }, "E-MAIL"),
  /*#__PURE__*/_createElementVNode("span", { class: "col d-flex justify-content-start subtitulo" }, "DETALHES")
], -1))
const _hoisted_8 = { class: "col-5 d-flex justify-content-start" }
const _hoisted_9 = {
  style: {"white-space":"nowrap"},
  class: "texto bold cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_10 = { class: "col-5 d-flex justify-content-start" }
const _hoisted_11 = {
  style: {"white-space":"nowrap"},
  class: "texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_12 = { class: "col d-flex justify-content-start" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_14 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center p-8 w-100 h-100"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto cor_texto_1" }, "Nenhum usuário encontrado ...", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "d-flex justify-content-center align-items-center p-8 w-100 h-100"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto cor_texto_1" }, "Buscando usuarios...", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  style: {"width":"15rem","height":"3.2rem"},
  class: "card d-flex flex-row gap-2 justify-content-center align-items-center cursor-pointer"
}
const _hoisted_21 = {
  key: 0,
  style: {"color":"#dc3545"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"font-weight":"bold","font-size":"10"},
  class: "m-0 p-0 text-danger"
}, " Carregar mais ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalUsers = _resolveComponent("ModalUsers")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Usuários " + _toDisplayString(_ctx.lojaFixada && _ctx.lojaFixada.nomeFantasia), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          text: "Voltar",
          type: "button",
          onClick: _cache[0] || (_cache[0] = () => _ctx.router.back())
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          text: "Adicionar Usuário",
          style: {"min-width":"fit-content"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _hoisted_7,
      (_ctx.usersArray.length > 0 && !_ctx.isLoading.status)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.usersArray, (user, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              style: {"height":"fit-content","border-radius":"10px"},
              class: "usuario card d-flex flex-row col-12 p-5 align-items-center"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(user?.name || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(user?.email || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Button, {
                  variant: "primary",
                  text: "Editar",
                  onClick: ($event: any) => (_ctx.openModal(user))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        : (!_ctx.isLoading.status && _ctx.usersArray.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
    ]),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscaUsuario(_ctx.pagina + 1))),
      class: "align-items-center justify-content-center",
      id: "load",
      style: _normalizeStyle(`${(_ctx.usersArray.length > _ctx.limite - 1) ? 'display: flex' : 'display: none'}`)
    }, [
      _createElementVNode("div", _hoisted_20, [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
          : _createCommentVNode("", true),
        _hoisted_24
      ])
    ], 4),
    _createVNode(_component_ModalUsers, {
      fechaModal: _ctx.fechaModal,
      usuario: _ctx.usuarioModal
    }, null, 8, ["fechaModal", "usuario"])
  ]))
}